import { render, staticRenderFns } from "./opts-report.component.vue?vue&type=template&id=fd3c109a&scoped=true"
import script from "./opts-report.component.vue?vue&type=script&lang=js"
export * from "./opts-report.component.vue?vue&type=script&lang=js"
import style0 from "./opts-report.component.vue?vue&type=style&index=0&id=fd3c109a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3c109a",
  null
  
)

export default component.exports